<template>
    <div class="v-nav-item">
        <div @click="onClick" class="v-nav-item__link" :class="{'v-nav-item__link--has-dropdown': hasDropdown, 'v-nav-item__link--opened': isOpened}">
            <slot name="link"></slot>
        </div>
        <transition name="fade">
            <div class="v-nav-item__dropdown" v-show="isOpened">
                <slot name="default">
                    <!---->
                </slot>
            </div>
        </transition>
    </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NavItem extends BaseComponent {
    protected isOpened: boolean = false;
    protected hasDropdown: boolean = false;

    protected onClick(): void {
        if (this.hasDropdown) {
            this.isOpened = !this.isOpened;
        }
    }

    protected checkDropdowns(): boolean {
        return !!this.$slots.default;
    }

    protected mounted(): void {
        this.hasDropdown = this.checkDropdowns();
    }
}
</script>
<style lang="scss">
.v-nav-item__link {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;

    &--has-dropdown span:after,
    &--has-dropdown a:after {
        font-size: 18px;
        display: block;
        float: right;
        content: '\f107';
        font-family: 'FontAwesome';
    }

    &--opened span:after,
    &--opened a:after {
        content: '\f106';
    }
}

.v-nav-item__link span,
.v-nav-item__link a {
    overflow: hidden;
    display: block;
    padding: 10px 15px;

    &, &:hover, &:active, &:visited {
        color: #fff;
        text-decoration: none;
    }
}

.v-nav-item__dropdown {
    background-color: #e1774d;

    .v-nav-item__link {
        text-transform: none;
    }
}
</style>
